import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
// template components
import Table from '@nmx/template/dist/componentLibrary/components/Table';

// eslint-disable-next-line import/prefer-default-export
export const TableStyled = styled(Table)`
   ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      text-align: left;
      margin-bottom: ${mediumUp ? rem(40) : rem(32)};
    `;
  }}
`;
